import { Config, URLTypeSearchParam } from '../models/types'
import { getURLSearchParams } from './getURLSearchParams'

export const convertConfigURLParams = (
  searchParams: URLSearchParams,
  expectedParams: URLTypeSearchParam
): Partial<Config> => {
  const entriesParams = Object.entries(getURLSearchParams(searchParams))
    .filter(([key]) =>
      Object.keys(expectedParams).includes(key as keyof Config)
    )
    .map(([key, value]) => {
      const splitValue = value.split(', ')
      if (splitValue.length > 1) {
        return [key, splitValue]
      } else {
        if (expectedParams[key as keyof Config] === 'array') {
          return [key, [value] as string[]]
        } else {
          return [key, value]
        }
      }
    })

  return Object.fromEntries(entriesParams)
}
